import React from 'react'
import ResultsTable from '../../../ResultsTable'

function LinkRoleToOperationTable({ tableData }) {
   const columns = [
      {
         title: 'ROL',
         field: 'role',
         align: 'center',
         sorting: false
      },
      {
         title: 'APLICACIONES',
         field: 'application',
         align: 'center',
         sorting: false
      },
      {
         title: 'MÓDULOS',
         field: 'module',
         align: 'center',
         sorting: false
      },
      {
         title: 'FUNCIONALIDADES',
         field: 'functionality',
         align: 'center',
         sorting: false
      },
      {
         title: 'OPERACIONES',
         field: 'operation',
         align: 'center',
         sorting: false
      },
      {
         title: 'FECHA REGISTRO',
         field: 'createdDate',
         align: 'center',
         sorting: false
      },
      {
         title: 'USUARIO',
         field: 'createdBy',
         align: 'center',
         sorting: false
      }
   ]

   const parentChildBinding = (row, rows) =>
      rows.find(a => a.id === row.parentId)

   return (
      <ResultsTable
         columns={columns}
         tableData={{
            data: tableData
         }}
         parentChildData={parentChildBinding}
         customActions={[]}
      />
   )
}

export default LinkRoleToOperationTable
